import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  footerControls: {}
  nextButton: {}
  title: {}
  autoComplete: {}
  suggestion: { index: number }
}>('category')
